export const colors = {
  primary: '#0C0F24',
  secondary: '#19469D',
  success: '#12873D',
  warning: '#F59E0B',
  error: '#DC2626',
  white: '#ffffff',
  black: '#000000',
  gray50: '#B5B3B9',
  gray100: '#EAECEE',
  gray200: '#DBDFE3',
  gray300: '#F7F7F7',
  gray500: '#667380',
  gray800: '#111315',
  blue100: '#E4ECF4',
  blue400: '#3A6085',
  blue500: '#2B4763',
  blue800: '#0B1219',
  background: '#FFFFFF',
  royal10: '#E9EDF4',
  darkRoyal10: '#2A2E36',
  darkGray: '#303030',
  royal80: '#506CAA',
  royal100: '#445D95',
  paper: '#ffffff',
  text: '#111315',
  placeHolder: '#58595B',
  textSecondary: '#667380',
  textTertiary: '#506CAA',
  darkBackground: '#1A1A1A',
  darkBackground2: '#2C2C2C',
  darkPaper: '#333537',
  darkText: '#ffffff',
  darkTextSecondary: '#DBDFE3',
  darkTextTertiary: '#D3DAE9',
  textGrey: '#6C6C6C',
  darkNavy: '#31303F',
  subtleGray: '#D3E3FD',
  mistGray: '#D9DCE3',
  listItemButton: {
    light: {
      background: 'transparent',
      hover: '#D9DCE3',
      selected: '#D3E3FD',
      text: '#0C0F24',
    },
    dark: {
      background: 'transparent',
      hover: '#ffffff14',
      selected: '#90caf928',
      text: '#ffffff',
    },
  },
  feedBackIconsButton: {
    light: {
      background: '#677FAE',
      hover: '#0000000a',
      selected: '#D9DCE3',
      text: '#0C0F24',
    },
    dark: {
      background: '#D3DAE9',
      hover: '#ffffff14',
      selected: '#90caf928',
      text: '#ffffff',
    },
  },
  myExpResourcesButton: {
    light: {
      background: 'rgba(11, 15, 35, 1)',
      hover: 'rgba(217, 220, 227, 1)',
    },
    dark: {
      background: 'rgba(255, 255, 255, 1)',
      hover: 'rgba(90, 94, 107, 1)',
    },
  },
  switch: {
    light: {
      track: '#424242',
      thumb: '#ffffff',
      checkedTrack: '#4caf50',
    },
    dark: {
      track: '#e0e0e0',
      thumb: '#ffffff',
      checkedTrack: '#81c784',
    },
  },
  eXpResourcesLink: {
    light: {
      text: '#6C6C6C',
    },
    dark: {
      text: '#c0c0c0',
    },
  },
};
